<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Questionario Qualità
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chiudiDialog" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text style="overflow-y: auto; height: 100%">
      <v-row style="height: 100%">
        <v-col cols="3">
          <ListaDomande
            class="mt-3"
            style="max-height: 500px; overflow-y: auto"
            :visible="visible"
            :work_order_sel="work_order_sel"
          />
        </v-col>
        <v-col cols="9">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'check'"
            @fine_sessione_check="handleFineSessioneCheck"
            style="height: 100%"
            :input_args="input_args"
            :key="key_window_frame_check"
            @loaded="handleCheckLoaded()"
            ref="windowframe_check"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import ListaDomande from "@/components/PRODUCTION/ProduzioneLayout/ListaDomande.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "QuestionarioQualita",
  components: {
    ListaDomande,
    SnackbarQV,
    WindowFrame,
  },
  props: {
    props_questionario_qualita: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      dizionario_check: new Object(),
      input_args: new Object(),
      key_window_frame_check: 0,
      landing_page_check: "dashboard",

      // Modal
      window_frame_check_visible: false,
      window_frame_lista_visible: false,

      // Array
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          // Imposto i dati per lanciare il questionario.
          this.component_window_frame = "check";
          this.input_args = {
            toolbar_visible: false,
            esterno: 1,
          };

          this.input_args.id_questionario =
            this.props_questionario_qualita.id_modulo;
          this.input_args.colonne_lista_domande = 0;
          this.input_args.colonne_sezione_centrale_domande = 10;
          this.input_args.colonne_immagine_test = 2;
          this.input_args.id_relazione =
            this.props_questionario_qualita.id_relazione;
          this.input_args.id_relazione_log =
            this.props_questionario_qualita.id_relazione_log;
          this.landing_page_check =
            "quiz_detail/" + this.props_questionario_qualita.id_modulo;
          this.dizionario_check = {
            id_articolo: this.work_order_sel.id_articolo,
            id_ciclo_fasi: this.work_order_sel.id_ciclo_fasi,
            id_commessa: this.work_order_sel.id_commessa,
            id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          };

          this.input_args.esterno = 1;
          this.input_args.btn_indietro_quizdetail_visible = false;

          this.key_window_frame_check =
            this.key_window_frame_check == 0 ? 1 : 0;

          /* Lancio il questionario e metto a false
           * l'eventuale finestra di dialogo per confermare
           * o negare la volontà dell'utente di rispondere
           * a un questionario opzionale. */
          this.window_frame_check_visible = true;
        }
      },
    },
  },
  methods: {
    chiudiDialog() {
      console.log("entrato 1");
      this.$emit("click_chiudi");
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        dizionario: JSON.parse(JSON.stringify(this.dizionario_check)),
        landing_page: this.landing_page_check,
      });
    },
    handleFineSessioneCheck(arg) {
      if (arg.punteggio == null) {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      }

      if (arg.punteggio < 100) {
        // Stampo una snackbar di avviso.
        this.$refs.SnackbarQV.print(
          "orange",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );

        /* Mando una chiamata che mi genera una
         * segnalazione se il BE trova i flag giusti. */
        this.setSegnalazioneQuestionario({
          id_questionario: arg.id_questionario,
        });
      }

      if (arg.punteggio == 100) {
        this.$refs.SnackbarQV.print(
          "success",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      this.$emit("fine_sessione_check", arg.punteggio);
      console.log("entrato 2");
    },
    setSegnalazioneQuestionario(arg) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          token: localStorage.user_token,
          action: "setsegnalazionequestionario",
          id_ciclo_fasi: this.work_order_sel.id_ciclo_fasi,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_questionario: arg.id_questionario,
          cod_documento: "Commessa",
          num_documento: this.work_order_sel.cod_commessa,
          data_documento: moment().format("YYYY-MM-DD HH:mm:ss"),
          cod_articolo: this.work_order_sel.cod_articolo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Se tutto è andato ok, non faccio nulla.
            return;
          } else {
            // Se qualcosa è andato storto stampo una snackbar di errore.
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server nella generazione di una segnalazione."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server nella generazione di una segnalazione."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>